var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.166,
    cy: 56.3325,
    r: 54.4444,
    fill: "#CE0E2D",
    stroke: "#CE0E2D",
    strokeWidth: 3.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2444 56.8881C74.0361 56.8881 72.8575 56.6884 71.7285 56.3391V69.6656H40.026V56.3391C38.8969 56.6884 37.7085 56.8881 36.5051 56.8881C35.9654 56.8881 35.4256 56.8482 34.7967 56.7783C34.4719 56.7284 34.0955 56.5686 33.6974 56.4588L33.6984 77.6516C33.6984 80.2979 35.8267 82.4431 38.3631 82.4431H73.2349C75.8604 82.4431 77.8996 80.2979 77.8996 77.6516L77.9032 56.4588C77.4925 56.5668 77.1021 56.7293 76.6751 56.7864C76.3239 56.8482 75.7891 56.8881 75.2444 56.8881ZM81.5928 41.6948L75.9159 32.6427C75.4103 31.8292 74.5085 31.332 73.5459 31.332H38.2136C37.2512 31.332 36.3497 31.8291 35.8436 32.6427L30.1646 41.6948C27.2341 46.3696 29.8269 52.8652 35.3048 53.6138C35.699 53.6638 36.104 53.6937 36.5061 53.6937C39.095 53.6937 41.3878 52.5577 42.9625 50.8018C44.5323 52.5557 46.8399 53.6937 49.4149 53.6937C52.0038 53.6937 54.2966 52.5577 55.8713 50.8018C57.447 52.5557 59.7447 53.6937 62.3297 53.6937C64.9215 53.6937 67.2113 52.5577 68.786 50.8018C70.3618 52.5557 72.6595 53.6937 75.2345 53.6937C75.6446 53.6937 76.038 53.6664 76.4319 53.6145C81.9295 52.8751 84.5343 46.3766 81.5928 41.6948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.4fbe9eec75eb00d8b0c80e6e02642ddf.svg";
export { ForwardRef as ReactComponent };